import React, {useEffect} from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import {
    action_fetch_image_clogs,
    action_add_image_clogs
} from '../../../../store/actions/pages/c-log'
import { useParams } from 'react-router-dom'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

import List from './components/list'
import { useQuery } from '../../../hooks/common'
import { useRouteMatch } from 'react-router-dom'
import { matchRoutes } from 'react-router-config'
import routes from '../../../../routes/c-log'


const Details = props => {
    useStyles(classes)
    const params = useParams()
    const pageCLog = useSelector(state => state.pageCLog)
    const dispatch = useDispatch()
    const query = useQuery()
    const store = useStore()

    const match = useRouteMatch()

    useEffect(() =>{
        const branches = matchRoutes(routes, match.url)
        const routeExample = branches?.[0]?.route;

        window.pageTitle = routeExample?.cn_page
        if (window.GeekoSensors) {
            window.GeekoSensors.Quick('autoTrackSinglePage', {page_title: routeExample?.cn_page})
        }
    },[]);

    useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			delete window.__INITIAL_STATE__
		} else {
            window.scrollTo({
				top: 0,
			})
			Details.fetchData(store, params, query, {})
		}
	}, [params.id])

    const onRequest = () => {
        const id = params?.id
        dispatch(action_add_image_clogs({ id, skip: pageCLog?.imageSkip }, {}))
    }

    return <div>
        <div className={classes.List}>
            <List showings={pageCLog.imageClogs} request={onRequest} loading={pageCLog.imageLoading} finished={pageCLog.imageFinished}/>
        </div>
    </div>
}

Details.fetchData = async (store, params, search, headers) => {
    const id = params?.id

    // console.log(params)

    const list = await store.dispatch(action_fetch_image_clogs({ id }, headers))
    // console.log(list)
}

export default Details